export const API_KEY = {
    GET_USER: "v1/user/getuser",
    GET_ROLE: "v1/role/getrole",
    GET_SUBSCRIPTION: "v1/subscription/getsubscription",
    POST: "v1/user",
    PUT: "v1/user",
    DELETE: (id:number)=>`v1/user/${id}`,
}